import useAirportSearch, { OnlyCities } from '@/v2/location/AirportSearch'
import { forwardRef } from 'react'
import City from '@/logic/City'

import Autocomplete from '../ui/autocomplete'
import CitiesList from '../search/CitiesList'
import CustomButton from '@/v2/components/ui/CustomButton'

const DEFAULT_TYPE = 'default'

export const Anywhere = {
  type: DEFAULT_TYPE,
  selected: "N'importe où",
}

export const Paris = {
  type: DEFAULT_TYPE,
  selected: 'Paris (PAR)',
}

const createCity = (city) =>
  city.code === 'PAR' ? Paris : new City(city).searchOptionFormat

function findCityByIata(iata, cities) {
  if (cities?.hits?.length > 0) {
    const exactMatch = cities.hits.find(
      (city) =>
        city.code === iata ||
        city.airports.includes((airport) => airport.code == iata)
    )

    return createCity(exactMatch ?? cities.hits[0])
  }

  return undefined
}

export async function getOriginDestinationFromQuery(query, cities) {
  const originAirports = query.origin
    ? cities.search(query.origin, { limit: 50 })
    : Promise.resolve(undefined)
  const destinationAirpots = query.destination
    ? cities.search(query.destination, { limit: 50 })
    : Promise.resolve(undefined)

  return {
    origin: findCityByIata(query.origin, await originAirports),
    destination: findCityByIata(query.destination, await destinationAirpots),
  }
}

export function formatPlace(p) {
  if (!p || p.type === Anywhere.type) {
    return undefined
  }
  return p.value
}

export const CityAutoComplete = forwardRef(function AirportAutoComplete(
  {
    id,
    label,
    onSelect,
    selectedItem,
    error,
    defaultValue,
    showResetButton = true,
  },
  ref
) {
  const searchAirports = useAirportSearch(OnlyCities)

  return (
    <div className="flex gap-5 border rounded-5 border-dark-20 items-center">
      <Autocomplete
        id={id}
        label={label}
        onChange={onSelect}
        search={searchAirports}
        noBorder
        noBackground
        noShadow
        selectedItem={selectedItem}
        error={error}
        className="transform motion-safe:transition-all motion-safe:duration-200 bg-white ring-0 ring-transparent"
        inputClassName="text-primary"
        ref={ref}
      >
        {({ items, highlightedIndex }) => (
          <div className="absolute bg-white mt-5 rounded-5 shadow-double w-350 max-h-300 overflow-auto z-10">
            <CitiesList list={items} highlightedIndex={highlightedIndex} />
          </div>
        )}
      </Autocomplete>
      <div className="w-30 mx-5">
        {showResetButton &&
        selectedItem &&
        selectedItem.type !== DEFAULT_TYPE ? (
          <CustomButton
            size="xs"
            alt="Par défaut"
            onClick={() => onSelect(defaultValue)}
          >
            X
          </CustomButton>
        ) : (
          <>&nbsp;</>
        )}
      </div>
    </div>
  )
})
